import { fetchQuery, graphql } from "relay-runtime"
import {
  fetchServiceMappingsQuery,
  fetchServiceMappingsQuery$data,
} from "@/lib/__generated__/fetchServiceMappingsQuery.graphql"
import { cacheOrDefault } from "@/lib/cache-helper"
import { RelayEnvironment } from "@/relay-environment"

type ServiceMapping = {
  serviceMappings: fetchServiceMappingsQuery$data["serviceMappings"]
  appointmentTypeMappings: fetchServiceMappingsQuery$data["appointmentTypeMappings"]
}

let serviceMapping: ServiceMapping | null = null

const getServiceMapping = () => serviceMapping!

const ServiceMappingQuery = graphql`
  query fetchServiceMappingsQuery {
    serviceMappings {
      service
      specialty
      isAllowedInCountries
      isRequestRelevant
      isUrgent
      allowedAppointmentTypes
    }
    appointmentTypeMappings {
      appointmentType
      capacityPoints
      isFlatLength
      slotCount
    }
  }
`

const fetchServiceMapping = async () => {
  const data = await cacheOrDefault("serviceMapping", async () =>
    fetchQuery<fetchServiceMappingsQuery>(RelayEnvironment, ServiceMappingQuery, {}).toPromise(),
  )

  if (!data) {
    throw Error("Service mapping not fetched")
  }

  serviceMapping = data
}

export { fetchServiceMapping, getServiceMapping }
